import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="150%" height="150%" viewBox="0 0 745.000000 558.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,558.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3500 4311 c-104 -23 -168 -47 -255 -96 -431 -241 -569 -867 -286
-1301 52 -80 176 -214 198 -214 4 0 70 124 146 275 l137 275 140 0 141 0 -3
73 -3 72 -67 3 c-38 2 -68 7 -68 13 0 10 31 60 233 379 l85 135 -126 3 c-69 1
-130 -2 -135 -7 -8 -8 -137 -258 -370 -719 -125 -248 -112 -238 -168 -129 -73
144 -117 338 -106 476 29 358 283 617 690 702 80 17 137 22 269 22 93 0 166 2
165 4 -2 2 -44 12 -93 24 -132 30 -408 36 -524 10z"
          />
          <path
            d="M3838 3771 l-95 -148 -8 -287 -7 -287 342 7 342 7 -35 -69 c-108
-214 -287 -361 -514 -421 -84 -22 -120 -25 -253 -26 -85 -1 -190 5 -233 12
-43 7 -81 11 -83 8 -8 -7 204 -74 296 -94 59 -12 128 -18 225 -18 164 1 248
20 379 88 142 73 300 248 396 436 37 75 90 207 90 226 0 13 -51 15 -377 15
l-376 0 7 350 c3 193 5 350 3 350 -1 0 -46 -67 -99 -149z"
          />
          <path
            d="M1930 2571 c-50 -16 -116 -54 -152 -89 -34 -32 -36 -37 -20 -48 14
-10 22 -7 51 18 126 111 321 109 415 -3 26 -30 28 -31 44 -15 16 16 14 20 -34
66 -36 34 -66 53 -104 64 -56 17 -157 20 -200 7z"
          />
          <path
            d="M1915 2481 c-44 -20 -105 -68 -105 -82 0 -23 31 -17 78 15 91 61 202
57 279 -9 34 -29 41 -31 58 -19 18 13 18 14 -1 35 -10 12 -46 35 -79 50 -73
35 -166 39 -230 10z"
          />
          <path
            d="M1968 2420 c-39 -12 -95 -48 -102 -65 -9 -23 29 -38 45 -18 20 23 72
43 114 43 35 0 108 -30 120 -50 4 -6 13 -5 25 2 19 12 19 13 -7 40 -27 28
-107 59 -147 57 -12 0 -33 -4 -48 -9z"
          />
          <path
            d="M1517 2298 c-19 -19 -234 -499 -286 -641 -20 -53 20 -97 75 -83 19 5
32 23 54 71 l29 65 166 0 166 0 29 -65 c22 -48 35 -66 54 -71 35 -9 66 4 76
32 11 29 14 22 -149 399 -139 321 -157 345 -214 293z m107 -350 l45 -108 -115
0 -114 0 16 38 c8 20 34 82 57 136 41 99 41 99 53 70 7 -16 33 -77 58 -136z"
          />
          <path
            d="M2657 2302 c-15 -16 -17 -53 -17 -306 0 -268 1 -289 20 -326 39 -77
164 -127 210 -85 21 19 26 60 10 85 -5 8 -30 21 -56 30 -39 12 -49 21 -56 45
-4 17 -8 144 -7 284 0 226 -2 255 -17 272 -22 24 -66 24 -87 1z"
          />
          <path
            d="M3894 2312 c-31 -20 -34 -54 -34 -370 0 -308 1 -320 21 -346 25 -31
61 -34 89 -6 16 16 20 33 20 83 0 55 3 67 25 87 l24 23 68 -74 c116 -126 130
-139 155 -139 26 0 58 27 58 49 0 7 14 -1 30 -19 l30 -32 153 4 c145 3 155 5
217 34 79 37 128 78 169 142 65 101 75 231 26 340 -32 70 -115 155 -184 189
-52 26 -67 28 -214 33 -87 3 -167 2 -178 -2 -11 -4 -24 -19 -29 -33 -6 -15
-10 -158 -11 -333 0 -192 -4 -300 -9 -287 -5 11 -50 63 -99 115 l-90 95 79 79
c85 84 98 116 62 149 -36 33 -60 21 -170 -84 l-107 -101 -5 190 c-4 139 -9
193 -19 205 -14 17 -57 22 -77 9z m801 -141 c129 -59 191 -207 136 -326 -46
-100 -126 -144 -272 -152 l-99 -6 0 252 0 251 98 0 c72 0 107 -5 137 -19z"
          />
          <path
            d="M1971 2284 c-27 -35 -26 -59 4 -89 30 -30 54 -31 89 -4 17 14 26 30
26 50 0 65 -80 93 -119 43z"
          />
          <path
            d="M3002 2294 c-22 -15 -30 -66 -14 -90 43 -65 148 -10 121 63 -15 41
-68 55 -107 27z"
          />
          <path
            d="M5724 2255 l-25 -25 3 -228 c3 -206 5 -231 24 -273 46 -99 141 -160
248 -160 139 0 254 95 188 154 -25 23 -50 21 -97 -8 -76 -47 -170 -26 -215 47
-16 27 -20 51 -20 131 l0 97 113 0 c125 0 147 9 147 62 0 48 -25 58 -148 58
l-112 0 0 60 c0 51 -4 65 -25 85 -31 32 -50 31 -81 0z"
          />
          <path
            d="M3420 2111 c-76 -25 -136 -78 -169 -151 -18 -39 -21 -66 -21 -201 0
-139 2 -158 18 -172 24 -22 65 -21 85 1 14 15 17 41 17 143 0 149 9 188 56
228 42 37 101 42 151 11 54 -32 63 -63 63 -210 0 -160 11 -190 72 -190 49 0
58 28 58 185 0 159 -11 208 -61 268 -47 57 -109 89 -182 93 -34 2 -73 0 -87
-5z"
          />
          <path
            d="M5222 2102 c-154 -55 -231 -237 -159 -378 68 -133 224 -193 349 -134
l47 22 29 -22 c35 -26 65 -21 88 16 13 20 16 48 12 162 -3 126 -6 142 -31 194
-62 126 -205 186 -335 140z m166 -132 c127 -78 74 -280 -73 -280 -49 0 -102
26 -128 62 -30 40 -34 124 -8 166 44 69 140 94 209 52z"
          />
          <path
            d="M6428 2106 c-67 -18 -120 -57 -156 -113 -54 -86 -63 -172 -27 -260
21 -49 95 -124 145 -145 62 -27 154 -26 214 3 l47 22 20 -22 c25 -26 50 -27
80 -2 23 19 24 24 23 163 -1 155 -11 196 -69 273 -54 70 -183 108 -277 81z
m153 -139 c48 -32 71 -81 66 -140 -16 -188 -297 -176 -297 12 0 120 133 194
231 128z"
          />
          <path
            d="M1977 2092 c-15 -16 -17 -49 -17 -250 0 -219 1 -233 20 -252 28 -28
64 -25 89 6 20 25 21 39 21 235 0 202 -6 254 -33 271 -22 14 -64 8 -80 -10z"
          />
          <path
            d="M2393 2094 c-60 -22 -127 -86 -160 -152 -27 -54 -28 -64 -28 -193 0
-120 2 -139 19 -158 22 -25 53 -27 83 -6 19 14 21 25 25 153 3 134 4 140 31
175 32 42 65 62 121 70 48 8 76 32 76 67 0 57 -73 77 -167 44z"
          />
          <path
            d="M3000 2090 c-19 -19 -20 -33 -20 -248 0 -226 0 -229 23 -250 30 -28
61 -28 87 0 19 21 20 34 20 248 0 188 -3 229 -16 248 -19 28 -67 29 -94 2z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
